import { render, staticRenderFns } from "./AnswerAb.vue?vue&type=template&id=dcc267e0&"
import script from "./AnswerAb.vue?vue&type=script&lang=ts&"
export * from "./AnswerAb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports